import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CampusUnitsFaqSection, CampusUnitsFaq } from '../../models';
import { Observable } from 'rxjs';

@Injectable()
export class CampusUnitsCommunicationsDataService {
  private baseUrl = 'api/campus-units-communications';

  constructor(private http: HttpClient) { }

  // private handleLookUpError(error: HttpErrorResponse) {
  //   if (error.status === 404) {
  //     return Observable.of(null);
  //   }
  //   return new ErrorObservable('Unable to load data');
  // }

  getSections(): Observable<CampusUnitsFaqSection[]> {
    return this.http.get<CampusUnitsFaqSection[]>(`${this.baseUrl}/sections`);
  }

  updateSection(section: CampusUnitsFaqSection): Observable<CampusUnitsFaqSection> {
    return this.http.post<CampusUnitsFaqSection>(`${this.baseUrl}/update/section`, section);
  }

  updateQuestion(question: CampusUnitsFaq): Observable<CampusUnitsFaq> {
    return this.http.post<CampusUnitsFaq>(`${this.baseUrl}/update/question`, question);
  }

  updateSections(sections: CampusUnitsFaqSection[]): Observable<CampusUnitsFaqSection[]> {
    return this.http.post<CampusUnitsFaqSection[]>(`${this.baseUrl}/update/sections`, sections);
  }

  createSection(section: CampusUnitsFaqSection): Observable<CampusUnitsFaqSection> {
    return this.http.post<CampusUnitsFaqSection>(`${this.baseUrl}/create/section`, section);
  }

  createQuestion(question: CampusUnitsFaq): Observable<CampusUnitsFaq> {
    return this.http.post<CampusUnitsFaq>(`${this.baseUrl}/create/question`, question);
  }

  deleteQuestion(questionId: number) {
    return this.http.delete(`${this.baseUrl}/question/${questionId}`);
  }

  deleteSection(sectionId: number) {
    return this.http.delete(`${this.baseUrl}/section/${sectionId}`);
    // return this.http.post<number>(`${this.baseUrl}/delete/section`, sectionId)
  }
}
